module.exports = __webpack_public_path__ + "img/customer_1_de.03bac537.png";